import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs/internal/Observable';
import { getRolesByInstitution } from './query';

interface catalogos {
  name: string;
  last_name: string;
  last_name2: string;
  email: string;
  role_name: string;
  institution_id?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ResponsablesPlanesService {
  private apiURL = environment.api_cuestionariosA_rest;
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private cookieService: CookieService,
    private http: HttpClient,
    private apollo: Apollo
  ) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', 'Bearer ' + localStorage.getItem('token'));
  }

  public postCatalogo(catalogo): Observable<any> {
    const cat: catalogos = {
      name: catalogo.name,
      last_name: catalogo.last_name,
      last_name2: catalogo.last_name2,
      email: catalogo.email,
      role_name: catalogo.role_name,
      institution_id: catalogo.institution_id
    }
    const apiURL = this.apiURL + "roles";
    return this.http.post(apiURL, cat, { headers: this.getHeaders() });
  }

  public getCatalogos(institutionId: string): Observable<any> {
    return this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
      query: getRolesByInstitution,
      context: { headers: this.headers },
      variables: {
        institutionId: institutionId
      },
      fetchPolicy: 'no-cache'
    }).valueChanges;
  }

  public deleteCatalogo(id: string): Observable<any> {
    const apiURL = this.apiURL + "roles/" + id;
    return this.http.delete(apiURL, { headers: this.getHeaders() });
  }

  public updateCatalogo(catalogo): Observable<any> {
    const cat: catalogos = {
      name: catalogo.name,
      last_name: catalogo.last_name,
      last_name2: catalogo.last_name2,
      email: catalogo.email,
      role_name: catalogo.role_name
    }
    const apiURL = this.apiURL + "roles/" + catalogo.id;
    return this.http.patch(apiURL, cat, { headers: this.getHeaders() });
  }
}
